import { render, staticRenderFns } from "./PrintExpiredPayments.vue?vue&type=template&id=b2de34a0&scoped=true"
import script from "./PrintExpiredPayments.vue?vue&type=script&lang=js"
export * from "./PrintExpiredPayments.vue?vue&type=script&lang=js"
import style0 from "./PrintExpiredPayments.vue?vue&type=style&index=0&id=b2de34a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2de34a0",
  null
  
)

export default component.exports